'use client';

import { useGamesList } from '@shared/hooks';
import { InnerPageContainer } from '../../../../InnerPageContainer/InnerPageContainer';
import { TermsAndConditions } from '../../../components/TermsAndConditions/TermsAndConditions';
import { Accordion } from '../../components/Accordion';
import { CRMContent } from '../../components/CRMContent';
import { CRMHeader } from '../../components/CRMHeader';
import { GamesCarousel } from '../../components/GamesCarousel';
import type { NetworkPromoLandingPageData } from './types.ts';

type NetworkPromoLandingPageProps = {
  landingPageData: NetworkPromoLandingPageData;
};

function NetworkPromoLandingPage({ landingPageData }: NetworkPromoLandingPageProps): React.JSX.Element {
  const { games: allGames } = useGamesList();
  const { list } = landingPageData;
  const { image, heading, subheading, description, accordions, pods, tags, termsAndConditions, validUntil: validUntilDate } = list[0]!;
  const filteredGames = allGames.filter(game => pods?.some(pod => pod.gameId?.toLowerCase() === game?.name?.toLowerCase()));

  const trackingAttributes: Record<string, string> = {
    'data-track-container': 'Offer',
    'data-track-product': 'Games',
    'data-track-name': heading,
    'data-track-type': 'No Opt In',
    'data-track-expiration-date': validUntilDate,
  };

  return (
    <InnerPageContainer {...trackingAttributes}>
      {image?.link && <CRMHeader image={image} />}

      <div className="ll-grid-container pt-5 pb-8 sm-md:[--ll-container-padding:40px]">
        <CRMContent title={heading} subheading={subheading || description} validUntilDate={validUntilDate} callout={tags?.callout} sectionClassName="ll-container-inner">
          {filteredGames?.length > 0 && <GamesCarousel carouselGames={filteredGames} />}
        </CRMContent>

        <Accordion items={accordions} />

        {termsAndConditions && (
          <section className="ll-container-inner flex flex-col items-start pb-16 md:pb-0 mt-6 md:mt-8" data-testid="crm-terms-and-conditions">
            <TermsAndConditions information={termsAndConditions} isSmallText={true} />
          </section>
        )}
      </div>
    </InnerPageContainer>
  );
}

export { NetworkPromoLandingPage };
